export const BasemapType = {
    GALLERY: 'gallery',
    OGC: 'ogc',
};